import { useEffect, useState } from "react";

const readCurrentLanguage = () => {
  if (typeof window === "undefined") {
    return "fr";
  }

  return (
    sessionStorage.getItem("currentlanguage") ||
    document.documentElement.lang ||
    navigator.language ||
    "fr"
  ).toLowerCase();
};

export default function useCurrentLanguage() {
  const [currentLanguage, setCurrentLanguage] = useState(readCurrentLanguage);

  useEffect(() => {
    const syncLanguage = () => {
      setCurrentLanguage(readCurrentLanguage());
    };

    const observer = new MutationObserver((mutations) => {
      if (
        mutations.some(
          (mutation) =>
            mutation.type === "attributes" && mutation.attributeName === "lang"
        )
      ) {
        syncLanguage();
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["lang"],
    });

    return () => observer.disconnect();
  }, []);

  return currentLanguage;
}
